const TEXT = {

  PROPERTY_ALL_SEO_PLURAL: "Shops for rent",
  PROPERTY_ALL_SEO_SINGLE: "Shop for rent",
  SCHEME_ALL_SEO_PLURAL: "Retail Centres",
  SCHEME_ALL_SEO_SINGLE: "retail centre",
  SCHEME_BP_SEO_PLURAL: "Business Parks",
  SCHEME_BP_SEO_SINGLE: "business park",
  SCHEME_HS_SEO_PLURAL: "Shops for rent in High Streets",
  SCHEME_HS_SEO_SINGLE: "high street",
  SCHEME_IN_SEO_PLURAL: "Shops for rent in Industrial Parks",
  SCHEME_IN_SEO_SINGLE: "industrial park",
  SCHEME_LE_SEO_PLURAL: "Shops for rent in Leisure Parks",
  SCHEME_LE_SEO_SINGLE: "leisure park",
  SCHEME_RW_SEO_PLURAL: "Shops for rent in Retail Parks",
  SCHEME_RW_SEO_SINGLE: "retail park",
  SCHEME_SC_SEO_PLURAL: "Shops for rent in Shopping Centres",
  SCHEME_SC_SEO_SINGLE: "shopping centre",
  SCHEME_SP_SEO_PLURAL: "Shops for rent in Shopping Parks",
  SCHEME_SP_SEO_SINGLE: "shopping park",

  SEARCH_PROPERTY_LOCATION_ALL_PLACEHOLDER: "Begin typing a location to search for shops",
  SEARCH_PROPERTY_NAME_ALL_PLACEHOLDER: "Begin typing the name of the shop",
  SEARCH_SCHEME_LOCATION_ALL_PLACEHOLDER: "Begin typing a location to search for schemes",
  SEARCH_SCHEME_NAME_ALL_PLACEHOLDER: "Begin typing the name of the scheme",

  PROPERTY_ALL_LABEL_UPPER_PLURAL: "Retail Units & Shops",
  PROPERTY_ALL_LABEL_UPPER_SINGLE: "Retail Shop to Rent",
  PROPERTY_ALL_LABEL_LOWER_PLURAL: "shops & retail units",
  PROPERTY_ALL_LABEL_LOWER_SINGLE: "retail shop to rent",
  PROPERTY_ALL_NEW: "shops & retail units",
  PROPERTY_ALL_URI: "shops-to-rent",
  PROPERTY_ALL_FOR_SALE_URI: "shops-for-sale",
  PROPERTY_ALL_META:
    "Search for specific retail shops to rent | Check availability of retail shops to rent on UK’s largest retail scheme database here.",
  PROPERTY_ALL_META_FOR_SALE:
    "Search for specific retail shops for sale | Check availability of retail shops for sale on UK’s largest retail scheme database here.",
  PROPERTY_ALL_BLURB: [],
  PROPERTY_ALL_DESCRIPTION: "Search our property list to find available retail space and shops for rent in",

  PROPERTY_ALL_LABEL_UPPER_PLURAL_FOR_SALE: "Retail Units & Shops For Sale",
  PROPERTY_ALL_LABEL_UPPER_SINGLE_FOR_SALE: "Retail Shop For Sale",
  PROPERTY_ALL_LABEL_LOWER_PLURAL_FOR_SALE: "shops & retail units for sale",
  PROPERTY_ALL_LABEL_LOWER_SINGLE_FOR_SALE: "retail shop for sale",
  PROPERTY_ALL_NEW_FOR_SALE: "shops & retail units for sale",
  PROPERTY_ALL_URI_FOR_SALE: "shops-for-sale",
  PROPERTY_ALL_META_FOR_SALE:
    "Search for specific retail shops for sale | Check availability of retail shops for sale on UK’s largest retail scheme database here.",
  PROPERTY_ALL_BLURB_FOR_SALE: [],
  PROPERTY_ALL_DESCRIPTION_FOR_SALE: "Search our property list to find available retail space and shops for sale in",
  PROPERTY_ALL_SEO_PLURAL_FOR_SALE: "Retail Units & Shops for sale",
  PROPERTY_ALL_SEO_PLURAL_FOR_SALE_META: "Shops for sale",
  PROPERTY_ALL_SEO_SINGLE_FOR_SALE: "retail units & shops for sale",

  SCHEME_ALL_LABEL_UPPER_PLURAL: "Shops for let in Retail Centres at",
  SCHEME_ALL_LABEL_UPPER_PLURAL_TITLE: "Shops for let at Retail Centres",
  SCHEME_ALL_LABEL_UPPER_SINGLE: "Retail Center",
  SCHEME_ALL_LABEL_LOWER_PLURAL: "retail centres",
  SCHEME_ALL_LABEL_LOWER_SINGLE: "retail centre",
  SCHEME_ALL_NEW: "retail centres to rent",
  SCHEME_ALL_URI: "retail-centres",
  SCHEME_ALL_META:
    "Search for specific shopping centres, leisure or retail parks | Check availability of retail units to let on UK’s largest retail center database here.",
  SCHEME_ALL_BLURB: [
    "While looking for retail units to rent it's important to have the most up to date information, we are proud to work with major landlords and agents to ensure Completely Retail is the go- to website when searching for retail property.",
    "Whether you're looking for a shop to rent in a popular London shopping centre or checking availability at a retail park in Liverpool, here you can find exactly what you’re looking for from our database of over 5, 000 schemes across the UK.",
    "Start your retail and shopping park search below by entering the area you’re interested in.",
  ],
  SCHEME_ALL_DESCRIPTION: "Explore Completely Retail’s database to discover available retail center units to rent in ",

  SCHEME_BP_LABEL_UPPER_PLURAL: "Business Parks",
  SCHEME_BP_LABEL_LANDSEC: "Business Parks",
  SCHEME_BP_LABEL_UPPER_SINGLE: "Business Park",
  SCHEME_BP_LABEL_LOWER_PLURAL: "business parks",
  SCHEME_BP_LABEL_LOWER_SINGLE: "business park",
  SCHEME_ALL_NEW: "New Business Parks",
  SCHEME_BP_URI: "business-parks",
  SCHEME_BP_META: "",
  SCHEME_BP_BLURB: [],
  SCHEME_BP_DESCRIPTION: "",

  SCHEME_HB_LABEL_UPPER_PLURAL: "",
  SCHEME_HB_LABEL_UPPER_SINGLE: "",
  SCHEME_HB_LABEL_LOWER_PLURAL: "",
  SCHEME_HB_LABEL_LOWER_SINGLE: "",
  SCHEME_HB_NEW: "",
  SCHEME_HB_URI: "",
  SCHEME_HB_META: "",
  SCHEME_HB_BLURB: [],

  SCHEME_HS_LABEL_UPPER_PLURAL: "Shops for rent in High Streets Schemes",
  SCHEME_HS_LABEL_UPPER_PLURAL_TITLE: "Shops to let in High Streets Schemes",
  SCHEME_HS_LABEL_LANDSEC: "High Streets Schemes",
  SCHEME_HS_LABEL_UPPER_SINGLE: "High Street Scheme",
  SCHEME_HS_LABEL_LOWER_PLURAL: "high streets schemes",
  SCHEME_HS_LABEL_LOWER_SINGLE: "high street scheme",
  SCHEME_HS_NEW: "New High Streets",
  SCHEME_HS_URI: "high-street",
  SCHEME_HS_META:
    "Search for high street units to let on the UK’s most complete shopping centre database | There’s no better place to find commercial retail property.",
  SCHEME_HS_BLURB: [
    "Completely Retail is the definitive database for high streets schemes in the UK. We are proud to work with major landlords and agents to ensure we have the most up to date information on retail property throughout the country.",
    "Enter a location below to search high streets schemes in that area and find your perfect high street unit to let.",
  ],
  SCHEME_HS_DESCRIPTION: "",

  SCHEME_IN_LABEL_UPPER_PLURAL: "Shops for rent in Industrial Parks",
  SCHEME_IN_LABEL_LANDSEC: "Industrial Parks",
  SCHEME_IN_LABEL_UPPER_SINGLE: "Industrial Park",
  SCHEME_IN_LABEL_LOWER_PLURAL: "industrial parks",
  SCHEME_IN_LABEL_LOWER_SINGLE: "industrial park",
  SCHEME_IN_NEW: "New Industrial Parks",
  SCHEME_IN_URI: "industrialparks",
  SCHEME_IN_META: "",
  SCHEME_IN_BLURB: [],
  SCHEME_IN_DESCRIPTION: "",

  SCHEME_LE_LABEL_UPPER_PLURAL: "Shops for rent in Leisure Schemes",
  SCHEME_LE_LABEL_UPPER_PLURAL_TITLE: "Shops to let in Leisure Schemes",
  SCHEME_LE_LABEL_LANDSEC: "Our Leisure Parks",
  SCHEME_LE_LABEL_UPPER_SINGLE: "Leisure Scheme",
  SCHEME_LE_LABEL_LOWER_PLURAL: "leisure schemes",
  SCHEME_LE_LABEL_LOWER_SINGLE: "leisure scheme",
  SCHEME_LE_NEW: "New Leisure Schemes",
  SCHEME_LE_URI: "leisure-schemes",
  SCHEME_LE_META:
    "Browse the UK’s largest retail unit database for leisure property to let | Search for schemes to accommodate all your Leisure, Food & Beverage needs here.",
  SCHEME_LE_BLURB: [
    "Trying to find the ideal place for your next restaurant, hotel, gym or bar? Enter a search location below and begin your journey to the perfect leisure property.",
    "Searching leisure schemes is a great way to find a property with the parking and transport provisions you need to feed your business while also providing an overview of local tenants occupying the same area.If you’re looking for leisure property to let this is a great place to start your search.",
  ],
  SCHEME_LE_DESCRIPTION: "",

  SCHEME_LO_LABEL_UPPER_PLURAL: "Logistics",
  SCHEME_LO_LABEL_UPPER_SINGLE: "Logistics",
  SCHEME_LO_LABEL_LOWER_PLURAL: "logistics",
  SCHEME_LO_LABEL_LOWER_SINGLE: "logistics",
  SCHEME_LO_NEW: "New Logistics",
  SCHEME_LO_URI: "logistics",
  SCHEME_LO_META: "",
  SCHEME_LO_BLURB: [],

  SCHEME_OF_LABEL_UPPER_PLURAL: "Offices",
  SCHEME_OF_LABEL_UPPER_SINGLE: "Office",
  SCHEME_OF_LABEL_LOWER_PLURAL: "offices",
  SCHEME_OF_LABEL_LOWER_SINGLE: "office",
  SCHEME_OF_NEW: "Offices",
  SCHEME_OF_URI: "offices",
  SCHEME_OF_META: "",
  SCHEME_OF_BLURB: [],

  SCHEME_RW_LABEL_UPPER_PLURAL: "Shops for rent in Retail & Shopping Parks",
  SCHEME_RW_LABEL_UPPER_PLURAL_TITLE: "Shops to let in Retail & Shopping Parks",
  SCHEME_RW_LABEL_LANDSEC: "Our Retail Parks",
  SCHEME_RW_LABEL_UPPER_SINGLE: "Retail & Shopping Park",
  SCHEME_RW_LABEL_LOWER_PLURAL: "retail & shopping parks",
  SCHEME_RW_LABEL_LOWER_SINGLE: "retail & shopping park",
  SCHEME_RW_NEW: "New Retail & Shopping Parks",
  SCHEME_RW_URI: "retail-parks",
  SCHEME_RW_META:
    "Search the UK’s most comprehensive Retail & Shopping Park property database | Discover shopping and retail park units to let in your ideal location.",
  SCHEME_RW_BLURB: [
    "Completely Retail is the UK’s most comprehensive database of Retail and Shopping parks. We work with the largest landlords and agents who regularly update Completely Retail with the latest available property so it couldn’t be simpler to find the perfect retail park unit to let for your business.",
    "Start a retail park search below by entering the area you’re interested in.",
  ],
  SCHEME_RW_DESCRIPTION: "",

  SCHEME_SC_LABEL_UPPER_PLURAL: "Shops for rent in Shopping Centres",
  SCHEME_SC_LABEL_UPPER_PLURAL_TITLE: "Shops to let in Shopping Centres",
  SCHEME_SC_LABEL_LANDSEC: "Our Centres",
  SCHEME_SC_LABEL_UPPER_SINGLE: "Shopping Centre",
  SCHEME_SC_LABEL_LOWER_PLURAL: "shopping centres",
  SCHEME_SC_LABEL_LOWER_SINGLE: "shopping centre",
  SCHEME_SC_NEW: "New Shopping centres",
  SCHEME_SC_URI: "shopping-centres",
  SCHEME_SC_META:
    "Search for shopping centre units to let on the UK’s most complete shopping centre database | There’s no better place to find commercial retail property.",
  SCHEME_SC_BLURB: [
    "Completely Retail is the definitive database for Shopping centres in the UK. We are proud to work with major landlords and agents to ensure we have the most up to date information on retail property throughout the country.",
    "Enter a location below to search shopping centres in that area and find your perfect shopping centre unit to let.",
  ],
  SCHEME_SC_DESCRIPTION: "",

  SCHEME_SP_LABEL_UPPER_PLURAL: "Shopping Parks",
  SCHEME_SP_LABEL_LANDSEC: "Shopping Parks",
  SCHEME_SP_LABEL_UPPER_SINGLE: "Shopping Park",
  SCHEME_SP_LABEL_LOWER_PLURAL: "shopping parks",
  SCHEME_SP_LABEL_LOWER_SINGLE: "shopping park",
  SCHEME_SP_NEW: "New Shopping parks",
  SCHEME_SP_URI: "shopping-parks",
  SCHEME_SP_META: "",
  SCHEME_SP_BLURB: [],

  SCHEME_TP_LABEL_UPPER_PLURAL: "Trade Parks",
  SCHEME_TP_LABEL_UPPER_PLURAL: "Trade Parks",
  SCHEME_TP_LABEL_UPPER_SINGLE: "Trade Park",
  SCHEME_TP_LABEL_LOWER_PLURAL: "trade parks",
  SCHEME_TP_LABEL_LOWER_SINGLE: "trade park",
  SCHEME_TP_NEW: "New Trade Parks",
  SCHEME_TP_URI: "trade-parks",
  SCHEME_TP_META: "",
  SCHEME_TP_BLURB: [],

  SCHEME_WO_LABEL_UPPER_PLURAL: "Workshops",
  SCHEME_WO_LABEL_UPPER_PLURAL: "Workshops",
  SCHEME_WO_LABEL_UPPER_SINGLE: "Workshop",
  SCHEME_WO_LABEL_LOWER_PLURAL: "workshops",
  SCHEME_WO_LABEL_LOWER_SINGLE: "workshop",
  SCHEME_WO_NEW: "New Workshops",
  SCHEME_WO_URI: "workshops",
  SCHEME_WO_META: "",
  SCHEME_WO_BLURB: [],

  FILTER_SPONSORSHIP_SPONSORED_MAIN: "Sponsored",
  FILTER_SPONSORSHIP_SPONSORED_LOGGING: "Sponsored",
  FILTER_SPONSORSHIP_SPONSORED_TOOLTIP: "Show results that are sponsored.",
  FILTER_SPONSORSHIP_UNSPONSORED_MAIN: "Unsponsored",
  FILTER_SPONSORSHIP_UNSPONSORED_LOGGING: "Unsponsored",
  FILTER_SPONSORSHIP_UNSPONSORED_TOOLTIP: "Show results that are not sponsored.",

  FILTER_KEYWORD_MAIN: "Filter results by keyword",
  FILTER_KEYWORD_NEAT: "Keyword",
  FILTER_KEYWORD_LOGGING: "Keyword",
  FILTER_KEYWORD_TAB: "Keyword",
  FILTER_KEYWORD_TAB_VAR: (value) => "Keyword",
  FILTER_KEYWORD_PLACEHOLDER: "Filter by keyword...",

  FILTER_CATEGORIES_MAIN: "Select which categories to show",
  FILTER_CATEGORIES_NEAT: "Categories",
  FILTER_CATEGORIES_LOGGING: "Category",
  FILTER_CATEGORIES_TAB: "Categories",
  FILTER_CATEGORIES_TAB_VAR: (value) => "Categories",
  FILTER_CATEGORIES_SC: "Shopping Centre",
  FILTER_CATEGORIES_LE: "Leisure Park",
  FILTER_CATEGORIES_HS: "High Street",
  FILTER_CATEGORIES_RW: "Retail Park",

  FILTER_USE_CLASS_MAIN: "Select which use classes to show",
  FILTER_USE_CLASS_NEAT: "Use Classes",
  FILTER_USE_CLASS_LOGGING: "Use Classes",
  FILTER_USE_CLASS_TAB: "Use Classes",
  FILTER_USE_CLASS_TAB_VAR: (value) => "Use Classes",
  FILTER_USE_CLASS_B1: "General industrial (B1)",
  FILTER_USE_CLASS_B8: "Storage or distribution (B8)",
  FILTER_USE_CLASS_C1: "Hotels (C1)",
  FILTER_USE_CLASS_C2: "Residential institutions (C2)",
  FILTER_USE_CLASS_C3: "Dwellinghouses (C3)",
  FILTER_USE_CLASS_E: "Commercial, Business and Service (E)",
  FILTER_USE_CLASS_F1: "Learning and non-residential institutions (F1)",
  FILTER_USE_CLASS_F2: "Local community (F2)",
  FILTER_USE_CLASS_S: "Other",

  FILTER_AVAILABILITY_MAIN: "Select the availability you'd like to filter your results by",
  FILTER_AVAILABILITY_NEAT: "Availability",
  FILTER_AVAILABILITY_LOGGING: "Availability",
  FILTER_AVAILABILITY_TAB: "Availability",
  FILTER_AVAILABILITY_TAB_VAR: (value) => "Availability",
  FILTER_AVAILABILITY_ALL: "All",
  FILTER_AVAILABILITY_AVAILABLE: "Available",
  "FILTER_AVAILABILITY_UNDER-OFFER": "Under Offer",
  "FILTER_AVAILABILITY_FOR-SALE/MAY-LET": "For Sale/May Let",

  FILTER_RENT_MAIN: "Filter the results by price",
  FILTER_RENT_NEAT: "Rent",
  FILTER_RENT_LOGGING: "Price",
  FILTER_RENT_TAB: "Rent",
  FILTER_RENT_TAB_VAR: (value) => `< £${parseInt(value.max).toLocaleString("en-GB")} pa`,
  FILTER_RENT_NULL: "Show results without price information",
  FILTER_RENT_UNIT: "pa",
  FILTER_RENT_VALUE: (value) => `£${parseInt(value).toLocaleString("en-GB")} pa`,

  FILTER_PRICE_MAIN: "Filter the results by price",
  FILTER_PRICE_NEAT: "Rent",
  FILTER_PRICE_LOGGING: "Price",
  FILTER_PRICE_TAB: "Price Range",
  FILTER_PRICE_TAB_VAR: (value) => `< £${parseInt(value.max).toLocaleString("en-GB")} pm`,
  FILTER_PRICE_NULL: "Show results without price information",
  FILTER_PRICE_UNIT: "pa",
  FILTER_PRICE_VALUE: (value) => `£${parseInt(value).toLocaleString("en-GB")} pm`,

  FILTER_SIZE_MAIN: "Filter the results by size",
  FILTER_SIZE_NEAT: "Size",
  FILTER_SIZE_LOGGING: "Max Size(ft)",
  FILTER_SIZE_TAB: "Size",
  FILTER_SIZE_TAB_VAR: (value) => `< ${parseInt(value.max).toLocaleString("en-GB")} ft`,
  FILTER_SIZE_NULL: "Show results without size information",
  FILTER_SIZE_UNIT: "ft",
  FILTER_SIZE_VALUE: (value) => `${parseInt(value).toLocaleString("en-GB")} ft`,

  FILTER_SPACE_MAIN: "Filter the results by size",
  FILTER_SPACE_NEAT: "Size",
  FILTER_SPACE_LOGGING: "Max Size(ft)",
  FILTER_SPACE_TAB: "Space Size",
  FILTER_SPACE_TAB_VAR: (value) => `< ${parseInt(value.max).toLocaleString("en-GB")} ft`,
  FILTER_SPACE_NULL: "Show results without size information",
  FILTER_SPACE_UNIT: "ft",
  FILTER_SPACE_VALUE: (value) => `${parseInt(value).toLocaleString("en-GB")} ft`,

  FILTER_DISTANCE_MAIN: "Filter the results by distance",
  FILTER_DISTANCE_NEAT: "Distance",
  FILTER_DISTANCE_LOGGING: "Area",
  FILTER_DISTANCE_TAB: "Distance",
  FILTER_DISTANCE_TAB_VAR: (value) => `< ${parseInt(value.max).toLocaleString("en-GB")} km`,
  FILTER_DISTANCE_NULL: "Show results without distance information",
  FILTER_DISTANCE_UNIT: "ft",
  FILTER_DISTANCE_VALUE: (value) => `${parseInt(value).toLocaleString("en-GB")} km`,
};

export default TEXT;

export const TEMPLATES = {
  SEARCH_PLACEHOLDER: (CRITEREA, TYPE, CATEGORY) => {
    let text;

    switch (CRITEREA) {
      case "LOCATION":
        switch (TYPE) {
          case "PROPERTY":
            text = `Search by town or city`;
            break;
          case "POPUP":
            text = "Begin typing a location to search for units available for short-term bookings";
            break;
          case "SCHEME":
            text = `Search by town or city`;
            // text = `Begin typing a location to search for ${TEXT[`${TYPE}_${CATEGORY}_LABEL_LOWER_PLURAL`]}`;
            break;
        }
        break;

      case "NAME":
        text = `Begin typing the name of the ${TEXT[`${TYPE}_${CATEGORY}_LABEL_LOWER_SINGLE`]}`;
        break;
    }

    return text;
  },
  SEARCH_BUTTON: (CRITEREA, TYPE, CATEGORY) => {
    let text;

    switch (CRITEREA) {
      case "LOCATION":
        text = "View this area";
        break;

      case "NAME":
        text = `View this ${TEXT[`${TYPE}_${CATEGORY}_LABEL_LOWER_SINGLE`]}`;
        break;
    }

    return text;
  },
};
